import { createAction, props } from '@ngrx/store';
import { FileDownloadParams } from '@core/services/download/download.models';

export const downloadFile = createAction('[DOWNLOAD] DOWNLOAD_FILE', props<{ params: FileDownloadParams }>());
